import React from 'react'

export default () => (
  <div>
    <h1>Sign Up</h1>
  </div>
)
